import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import PatronNavbar from "../Patron_Navbar";
import "./UploadOpportunities.css";
import { makeAuthenticatedPATCHRequest } from "../../services/serverHelper";
import { patronProfilePoints } from "../../services/apis";
import {
  AiOutlineSave,
  AiOutlineFileText,
  AiOutlineCalendar,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlinePhone,
} from "react-icons/ai";
import { MdLocationOn, MdTheaters, MdEdit } from "react-icons/md";

const EditOpportunity = () => {
  const { accessToken } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({});
  const [updatedFormData, setUpdatedFormData] = useState({});
  const navigate = useNavigate();
  const { state } = useLocation();
  const { opportunity } = state || {};


  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const citiesByState = {
    "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool"],
    "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Tawang", "Pasighat", "Ziro"],
    Assam: ["Guwahati", "Jorhat", "Dibrugarh", "Silchar", "Nagaon"],
    Bihar: ["Patna", "Gaya", "Muzaffarpur", "Bhagalpur", "Darbhanga"],
    Chhattisgarh: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Raigarh"],
    Goa: ["Panaji", "Vasco da Gama", "Margao", "Mapusa", "Ponda"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
    Haryana: ["Faridabad", "Gurugram", "Rohtak", "Panipat", "Karnal"],
    "Himachal Pradesh": ["Shimla", "Mandi", "Solan", "Dharamshala", "Kullu"],
    Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh"],
    Karnataka: ["Bangalore", "Mysore", "Hubli", "Mangalore", "Belgaum"],
    Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"],
    "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
    Manipur: ["Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Kakching"],
    Meghalaya: ["Shillong", "Tura", "Jowai", "Nongpoh", "Williamnagar"],
    Mizoram: ["Aizawl", "Lunglei", "Champhai", "Saiha", "Kolasib"],
    Nagaland: ["Kohima", "Dimapur", "Mokokchung", "Tuensang", "Wokha"],
    Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur"],
    Punjab: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda"],
    Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner"],
    Sikkim: ["Gangtok", "Namchi", "Mangan", "Singtam", "Gyalshing"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
    Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"],
    Tripura: ["Agartala", "Dharmanagar", "Udaipur", "Kailashahar", "Belonia"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Allahabad"],
    Uttarakhand: ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur"],
    "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"],
  };


  let allLanguages = [
    "Assamese", "Bengali", "Bhili", "Bhojpuri", "Dogri", "Garhwali",
    "Gujarati", "Haryanvi", "Hindi", "Kannada", "Kashmiri", "Khasi",
    "Kokborok", "Konkani", "Kumaoni", "Maithili", "Malayalam", "Manipuri",
    "Marathi", "Mizo (Lushai)", "Nepali", "Odia", "Punjabi", "Rajasthani",
    "Santali", "Sindhi", "Tamil", "Telugu", "Tulu", "Urdu", "English",
    "Spanish", "French", "German", "Italian", "Portuguese",
    "Chinese (Simplified)", "Japanese", "Korean", "Russian",
  ];

  const purposeOfPerformance = [
    "Annual / Foundation Day", "Conference/ Workshop/ Training",
    "Employee Engagement", "Family functions",
    "National/ State Day Celebration", "Office Functions",
    "Performance for hotel guests", "Product Launch",
    "Special Day – Marriage, Anniversary", "Special Events", "Any other",
  ];

  const ArtNames = [
    "Bharatanatyam", "Bihu", "Chhau", "Dandiya Raas", "Dollu Kunitha",
    "Dumhal", "Garba", "Gaur Dance", "Giddha", "Gotipua", "Jhumar",
    "Kacchi Ghodi", "Kalbelia", "Karakattam", "Kathak", "Kathakali",
    "Kathakar", "Koli", "Kuchipudi", "Lavani", "Manipuri",
    "Mayurbhanj Chhau", "Mohiniyattam", "Odissi", "Raas Leela",
    "Sattriya", "Tamasha", "Tera Tali", "Thang-Ta", "Yakshagana",
    "Dhrupad", "Khayal", "Thumri", "Tappa", "Ghazal", "Qawwali",
    "Kriti", "Varnam", "Tillana", "Ragamalika", "Javali", "Swarajati",
    "Bhajans", "Kirtan", "Sufi Music", "Abhangas", "Shabad Kirtan (Sikh)",
    "Bansuri", "Dilruba", "Dholak", "Ektara", "Esraj", "Flute (Bansuri)",
    "Ghatam", "Harmonium", "Jal Tarang", "Mridangam", "Nadaswaram",
    "Pakhawaj", "Ravanahatha", "Sarangi", "Sarod", "Santoor", "Shehnai",
    "Sitar", "Tabla", "Tanpura", "Tumbi", "Veena", "Bhavai",
    "Bhand Pather", "Jatra", "Koodiyattam", "Mudiyettu", "Nautanki",
    "Pandavani", "Pothu Koothu", "Ramlila", "Ram Lila", "Ras Leela",
    "Sattriya", "Tamaasha", "Therukoothu", "Yakshagana",
  ];

  const venueTypes = [
    "Banquette Hall", "Classroom", "Corporate", "Hotel", "Open Ground",
    "Private House", "Theater", "Training Center", "Any other",
  ];

  const performanceFacilitiesaArr = [
    "Accommodation", "Food", "Light", "Local Travel", "Musical Instruments",
    "Outstation Travel", "Photography", "Sound", "Stage", "Video", "Any other",
  ];

  useEffect(() => {
    if (opportunity) {
      console.log(opportunity);
      opportunity.performanceDate = opportunity.performanceDate.split("T")[0];
      opportunity.applicationPeriod.start =
        opportunity.applicationPeriod.start.split("T")[0];
      opportunity.applicationPeriod.end =
        opportunity.applicationPeriod.end.split("T")[0];
      setFormData(opportunity);
    }
  }, [opportunity]);

  const inputChangeHandler = (e) => {
    setUpdatedFormData((prevState) => {
      if (e.target.name === "start" || e.target.name === "end") {
        const applicationPeriod = {
          [e.target.name]: e.target.value,
        };

        return {
          ...prevState,
          applicationPeriod: {
            ...prevState.applicationPeriod,
            ...applicationPeriod,
          },
        };
      }

      return { ...prevState, [e.target.name]: e.target.value };
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const toastId = toast.loading("Loading...");
    console.log(updatedFormData);
    console.log(formData);
    try {
      const response = await makeAuthenticatedPATCHRequest(
        `${patronProfilePoints.UPDATE_OPPOR_API}/${opportunity._id}`,
        updatedFormData,
        accessToken
      );
      console.log("res", response.data);

      if (response.statusCode === 200) {
        toast.success("successfully saved");
        navigate(-1);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong, please try again");
    }
    toast.dismiss(toastId);
  };

  return (
    <>
      <PatronNavbar />
      <div className="modern_upload_opp_page">
        {/* Hero Section */}
        <div className="modern_upload_hero">
          <div className="modern_upload_hero_overlay">
            <h1 className="modern_upload_hero_title">
              <MdEdit style={{ marginRight: '0.5rem' }} />
              Edit Opportunity
            </h1>
            <p className="modern_upload_hero_subtitle">
              Update opportunity details and requirements
            </p>
          </div>
        </div>

        <div className="modern_upload_container">
          {/* Form */}
          <form onSubmit={submitHandler} className="modern_upload_form">
            {/* Performance Details Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <MdTheaters className="modern_section_icon" />
                Performance Details
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field modern_full_width">
                  <label className="modern_form_label">Purpose of Performance*</label>
                  <select
                    name="purpose"
                    onChange={inputChangeHandler}
                    data={formData?.purpose }
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.purpose || "Select purpose"}
                    </option>
                    {purposeOfPerformance?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field modern_full_width">
                  <label className="modern_form_label">Description*</label>
                  <input
                    name="description"
                    defaultValue={formData?.description}
                    onChange={inputChangeHandler}
                    type="text"
                    className="modern_form_input"
                    placeholder="Enter art description"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Location of Performance*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="location"
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.location?.state || "Select location"}
                    </option>
                    <option value="City/District">City/District</option>
                    <option value="State">State</option>
                    <option value="Country">Country</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Language of Performance*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="languages"
                    
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.languages || "Select language"}
                    </option>
                    {allLanguages?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Approx. Budget*</label>
                  <select
                    
                    onChange={inputChangeHandler}
                    name="budget"
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.budget || "Select budget"}
                    </option>
                    <option value="24000">Below 25000</option>
                    <option value="35000">25000-50000</option>
                    <option value="70000">50000-100000</option>
                    <option value="200000">100000-250000</option>
                    <option value="800000">250000-1000000</option>
                    <option value="1200000">Above 1000000</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Date of Performance*</label>
                  <input
                    
                    defaultValue={formData?.performanceDate}
                    name="performanceDate"
                    onChange={inputChangeHandler}
                    type="date"
                    className="modern_form_input"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Duration (hrs)*</label>
                  <input
                    
                    onChange={inputChangeHandler}
                    defaultValue={formData?.performanceDuration}
                    name="performanceDuration"
                    type="number"
                    className="modern_form_input"
                    placeholder="Enter duration"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Application Last Date*</label>
                  <input
                    
                    onChange={inputChangeHandler}
                    name="end"
                    defaultValue={formData?.applicationPeriod?.end}
                    type="date"
                    className="modern_form_input"
                  />
                </div>
              </div>
            </div>

            {/* Art Details Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <AiOutlineFileText className="modern_section_icon" />
                Art Details
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field">
                  <label className="modern_form_label">Type of Art*</label>
                  <select
                    
                    name="artType"
                    onChange={inputChangeHandler}
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.artType || "Select art type"}
                    </option>
                    <option value="Folk">Folk</option>
                    <option value="Classical">Classical</option>
                    <option value="Fusion">Fusion</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Category of Art*</label>
                  <select
                    
                    onChange={inputChangeHandler}
                    name="artCategory"
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.artCategory || "Select category"}
                    </option>
                    <option value="dance">Dance</option>
                    <option value="song">Song</option>
                    <option value="music">Music</option>
                    <option value="theater">Theater</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Name of Art*</label>
                  <select
                    
                    name="artName"
                    onChange={inputChangeHandler}
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.artName || "Select art name"}
                    </option>
                    {ArtNames?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Theme of Performance*</label>
                  <input
                    
                    onChange={inputChangeHandler}
                    defaultValue={formData?.theme}
                    name="theme"
                    type="text"
                    className="modern_form_input"
                    placeholder="Enter theme"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Live/Recorded/Part Live</label>
                  <select
                    onChange={inputChangeHandler}
                    name="mediaType"
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.mediaType || "Select type"}
                    </option>
                    <option value="Live">Live</option>
                    <option value="Recorded">Recorded</option>
                    <option value="PartLive">Part Live</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Need Customized Performance</label>
                  <select
                    onChange={inputChangeHandler}
                    name="customization"
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.customization ? "Yes" : "No"}
                    </option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Artist Requirements Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <AiOutlineUser className="modern_section_icon" />
                Artist Requirements
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field">
                  <label className="modern_form_label">No. of  Artists*</label>
                  <select
                    
                    name="Artists"
                    onChange={inputChangeHandler}
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.Artists || "Select count"}
                    </option>
                    <option value="1">1</option>
                    <option value="3">2-5</option>
                    <option value="7">5-10</option>
                    <option value="20">10-50</option>
                    <option value="60">Above 50</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Level of Artist*</label>
                  <select
                    
                    onChange={inputChangeHandler}
                    name="artistLevel"
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.artistLevel || "Select level"}
                    </option>
                    <option value="international">International</option>
                    <option value="national">National</option>
                    <option value="state">State</option>
                    <option value="district">District</option>
                    <option value="taluka">Taluka</option>
                    <option value="local">Local</option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Location of Artist*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="artistLocation"
                    
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.artistLocation || "Select location"}
                    </option>
                    <option value="local">Local</option>
                    <option value="outstation">Outstation</option>
                    <option value="Others">Others</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Venue & Audience Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <MdLocationOn className="modern_section_icon" />
                Venue & Audience
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field">
                  <label className="modern_form_label">Size of Audience*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="audienceSize"
                    
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.audienceSize || "Select size"}
                    </option>
                    <option value="20">Below 25</option>
                    <option value="35">25-50</option>
                    <option value="70">50-100</option>
                    <option value="300">100-500</option>
                    <option value="800">500-1000</option>
                    <option value="1200">Above 1000</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Profile of Audience*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="audienceProfile"
                    
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.audienceProfile || "Select profile"}
                    </option>
                    <option value="Hotel inhouse Guests">Hotel inhouse Guests</option>
                    <option value="Professional/ Executives">Professional/ Executives</option>
                    <option value="Students">Students</option>
                    <option value="Family Guests">Family Guests</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Venue of Performance*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="venue"
                    
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.venue || "Select venue"}
                    </option>
                    {venueTypes?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Performance Facilities*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="facilities"
                    
                    className="modern_form_input"
                  >
                    <option value="" hidden>
                      {formData?.facilities || "Select facilities"}
                    </option>
                    {performanceFacilitiesaArr?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field modern_full_width">
                  <label className="modern_form_label">Any Other Requirements</label>
                  <textarea
                    onChange={inputChangeHandler}
                    name="otherRequirements"
                    defaultValue={formData?.otherRequirements}
                    className="modern_form_textarea"
                    placeholder="Enter any additional requirements..."
                  />
                </div>
              </div>
            </div>

            {/* Contact Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <AiOutlinePhone className="modern_section_icon" />
                Contact Information
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field">
                  <label className="modern_form_label">Name</label>
                  <input
                    readOnly
                    defaultValue={opportunity?.contactPersonName}
                    name="Name"
                    type="text"
                    className="modern_form_input"
                    placeholder="Name of User"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Contact Number</label>
                  <input
                    readOnly
                    defaultValue={opportunity?.contactPersonNumber}
                    name="ContactNumber"
                    type="text"
                    className="modern_form_input"
                    placeholder="Contact Number"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Email</label>
                  <input
                    readOnly
                    defaultValue={opportunity?.contactEmail}
                    name="Email"
                    type="text"
                    className="modern_form_input"
                    placeholder="Email of User"
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="modern_upload_submit_wrapper">
              <button type="submit" className="modern_upload_submit_btn">
                <AiOutlineSave className="modern_submit_icon" />
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditOpportunity;